
import * as actionTypes from './actionTypes';
import * as actions from './index';

export const getEventRoomTreeStart = () => {
    return {
        type: actionTypes.EVENTROOMS_GET_PROJECT_TREE_START
    };
};

export const getEventRoomTreeSuccess = (children) => {
    return {
        type: actionTypes.EVENTROOMS_GET_PROJECT_TREE_SUCCESS,
        children: children
    };
};

export const getEventRoomTreeFail = (error) => {
    return {
        type: actionTypes.EVENTROOMS_GET_PROJECT_TREE_FAIL,
        error: error
    };
};


export const addEventRoomChildStart = () => {
    return {
        type: actionTypes.EVENTROOMS_CHILD_ADD_START
    }
};

export const addEventRoomChildSuccess = (project) => {
    return {
        type: actionTypes.EVENTROOMS_CHILD_ADD_SUCCESS,
        payload: { project: project }
    }
};

export const addEventRoomChildFail = (error) => {
    return {
        type: actionTypes.EVENTROOMS_CHILD_ADD_FAIL,
        error: error
    }
};

//OK
export const addEventRoomChild = ({ projectId, title, scheme, projectscheme }) => {
    console.log("LOGS: addEventRoomChild projectId", projectId);
    console.log("LOGS: addEventRoomChild title", title);
    return (dispatch => {
        dispatch({ type: actionTypes.EVENTROOMS_SET_LOADING, payload: { loading: true } });
        dispatch(addEventRoomChildStart());
        window.flow.distprojectAddNewChild(projectId, 'pmdb_eventroom', 0, { 'title': title })
            .then(res => {
                console.log("LOGS: addEventRoomChild res", res);
                dispatch(getEventRoomTree());
                dispatch(actions.getProjects());
                dispatch(addEventRoomChildSuccess(res));
                setTimeout(() => dispatch(actions.getEventRoomTree()), 2000);
            }).catch(err => {
                dispatch(addEventRoomChildFail(err));
                dispatch({ type: actionTypes.EVENTROOMS_SET_LOADING, payload: { loading: false } });
            });
    });
}

//OK
export const getEventRoomTree = () => {
    return dispatch => {
        dispatch({ type: actionTypes.EVENTROOMS_SET_LOADING, payload: { loading: true } });
        dispatch(getEventRoomTreeStart());
        console.log("LOGS: getEventRoomTree ");
        window.flow.distprojectGetFullTree('pmdb_eventroom', 0)
            .then(res => {
                console.log("LOGS: getEventRoomTree RES", res);
                dispatch(getEventRoomTreeSuccess(res.children));
                dispatch({ type: actionTypes.EVENTROOMS_SET_LOADING, payload: { loading: false } });
            }).catch(res => {
                dispatch(getEventRoomTreeFail(res.message));
                dispatch(actions.applicationError(res.message));
                dispatch({ type: actionTypes.EVENTROOMS_SET_LOADING, payload: { loading: false } });
            });
    };
};